/* eslint-disable prettier/prettier */
import Vue from 'vue';
import VueMeta from 'vue-meta';
import Disqus from 'vue-disqus';
import sanitizeHTML from 'sanitize-html';
import VueSanitize from "vue-sanitize";
import {
  Facebook,
  Twitter,
  Linkedin,
  WhatsApp,
  Email,
  Google
} from 'vue-socialmedia-share';
Vue.component('Facebook', Facebook);
Vue.component('Twitter', Twitter);
Vue.component('Linkedin', Linkedin);
Vue.component('WhatsApp', WhatsApp);
Vue.component('Email', Email);
Vue.component('Google', Google);
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import VueTimeago from 'vue-timeago';
import Meta from 'vue-meta';
import { BCarousel } from 'bootstrap-vue';
import VueProgressiveImage from 'vue-progressive-image';
//import jQuery from 'jquery';
Vue.component('b-carousel', BCarousel);
Vue.component('b-carousel-slide', BCarousel);
Vue.component('HelloI18n', require('./components/HelloI18n.vue').default);
Vue.component('Navigation', require('./components/Navigation.vue').default);
Vue.component('SlideShow', require('./components/SlideShow.vue').default);
Vue.component('TopBlog', require('./components/TopBlog.vue').default);
Vue.component('SideBar', require('./components/SideBar.vue').default);
Vue.component('OurNews', require('./components/OurNews.vue').default);
Vue.component('Pagination', require('./components/Pagination.vue').default);
Vue.component('Footer', require('./components/Footer.vue').default);
Vue.component('BreadsCrums', require('./components/BreadsCrums.vue').default);
Vue.component('NosValeurs', require('./components/NosValeurs.vue').default);
Vue.component('Download', require('./components/Download.vue').default);
Vue.component('Subscribe', require('./components/Subscribe.vue').default);
Vue.component('Articles', require('./components/Articles.vue').default);
Vue.component('Loader', require('./components/Loader.vue').default);
Vue.component('HomeBlogs', require('./components/HomeBlogs.vue').default);
Vue.component(
  'LightBoxVideo',
  require('./components/LightBoxVideo.vue').default
);

Vue.component(
  'LanguageSwitcher',
  require('./components/LanguageSwitcher.vue').default
);
Vue.component('Posts', require('./components/Posts.vue').default);

Vue.config.productionTip = false;
Vue.prototype.$sanitize = sanitizeHTML;
const defaultOptions = {
  allowedTags: false,
  allowedAttributes: false,
  transformTags: {
    'strong': 'b',
  }
};
Vue.use(VueSanitize, defaultOptions);
Vue.filter('striphtml', function(value) {
  var div = document.createElement('div');
  div.innerHTML = value;
  var text = div.textContent || div.innerText || '';
  return text;
});
Vue.use(VueTimeago, {
  name: 'Timeago', // Component name, `Timeago` by default
  locale: 'en',
  locales: {
    fr: require('date-fns/locale/fr')
  }
});
Vue.use(VueMeta);
Vue.use(VueProgressiveImage);
Vue.use(Meta);

Vue.use(Disqus);
// use beforeEach route guard to set the language
router.beforeEach((to, from, next) => {
  // use the language from the routing param or default language
  let language = to.params.lang;
  if (!language) {
    language = 'fr';
  }
  // set the current language for i18n.
  i18n.locale = language;
  next();
});

new Vue({
  router,
  i18n,
  data() {
    return {
      categoryId: ''
    };
  },
  render: h => h(App)
}).$mount('#app');
